
namespace Matrix {

    export class DataReportDashboard {
        private ul: JQuery;

        constructor() {

            var dropdown = $(`
<div class="dropdown favorite-views" style="float: right">
  <button class="btn btn-default dropdown-toggle" type="button" id="Favorites" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
    <i class="fa fa-star text-blue"></i> Favourite Views
    <span class="caret"></span>
  </button>
  <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
  </ul>
</div>
`)
                .prependTo(".grid-title");

            this.ul = dropdown.children("ul");
            this.ul.on('click', 'i.fa-trash-o', e => {
                var li = $(e.target).closest('li');
                var reportKey = li.data('report-key');
                var name = li.children('a').text();
                var favorites = this.getFavorites(reportKey);
                delete favorites[name];
                this.saveFavorites(reportKey, favorites);
                this.populateFavorites();
                Q.notifyWarning("View with name \"" + name + "\" is deleted.");
            });

            this.ul.on('click', 'a', e => {
                var reportKey = $(e.target).closest('li').data('report-key');
                var name = $(e.target).text();
                var favorites = this.getFavorites(reportKey);
                var settings = favorites[name];
                if (settings) {
                    window.location.href = Q.resolveUrl('~/DataReport/' + encodeURI(reportKey) + "?v=" +
                        encodeURIComponent(name));
                }
            });

            this.populateFavorites();
        }

        private populateFavorites() {
            var favorites = [];
            var used = {};
            var pre = Q.resolveUrl('~/DataReport/');
            var links = $('#SidebarMenu').find('li>a').each((i, e) => {
                var href = $(e).attr('href');
                if (href && Q.startsWith(href, pre) && href.indexOf('?') < 0) {
                    var reportKey = href.substr(pre.length);
                    if (used[reportKey])
                        return;
                    used[reportKey] = true;
                    var favs = this.getFavorites(reportKey);
                    if (!favs)
                        return;
                    var names = Object.keys(favs);
                    for (var name of names)
                        favorites.push([reportKey, name]);
                }
            });

            favorites.sort((a, b) => {
                return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0; 
            });
            this.ul.children().remove();

            for (var favorite of favorites) {
                var li = $('<li class="fav"><a href="javascript:;"></a></li>')
                    .appendTo(this.ul)
                    .data('report-key', favorite[0])
                    .children('a')
                    .text(favorite[1])
                    .end();

                $('<i class="fa fa-trash-o pull-right"></i>').appendTo(li);
            }
        }

        private saveFavorites(reportKey, favorites) {
            var storage = new Common.UserPreferenceStorage();
            var key = "Views:" + "DataReport:" + reportKey;
            storage.setItem(key, JSON.stringify(favorites));
        }

        private getFavorites(reportKey: string) {
            var storage = new Common.UserPreferenceStorage();
            var key = "Views:" + "DataReport:" + reportKey;
            return JSON.parse(storage.getItem(key) || "{}") || {};
        }
    }
}